/**
 * @class PartnerInfo
 * 업체정보 탭 내용
 */
export default class PartnerInfo {
  constructor() {
    // 필요 data 유효 확인
    const {
      bIsDeliveryDeal,
      htDealInfo: { localShopList },
    } = TMON.oApp.htStorage.htStaticData;
    if (bIsDeliveryDeal || (!localShopList && localShopList.length < 1)) return;

    this.sWrapper = '_wrapPartnerInfo';

    this.setEvent();
    this.render();
    this.showInfo();

    // PC 일 경우 다지점도 지도를 그림
    if (
      (localShopList.length === 1 || TMON.oApp.sPlatform === 'PW') &&
      localShopList[0] &&
      localShopList[0].location &&
      localShopList[0].location.lat &&
      localShopList[0].location.lon
    ) {
      $('.company__box').removeClass('no_map'); // pc 일때만 해당 element가 존재함
      this.renderMap(0);
    }
  }

  setEvent() {
    // toggle eventListener 등록
    $(`#${this.sWrapper}`).on(
      'click',
      '[data-role=toggleButton]',
      this.onClickToggle
    );
    // 지도보기 뷰 열기 eventListener 등록
    $(`#${this.sWrapper}`).on(
      'click',
      '[data-role=openInfo]',
      this.onClickOpenInfo
    );
    // html protocol 변경으로 인해 beforeunload event를 발생시키는 것을 방지
    $(`#${this.sWrapper}`).on('click', '[data-role=callToPartner]', () => {
      TMON.oApp.setStorage('bBlockWindowUnloadEvent', true);
    });
    // 길찾기 eventListener 등록
    if (TMON.view_mode === 'app') {
      $(`#${this.sWrapper}`).on(
        'click',
        '[data-role=openFindRoad]',
        this.onClickOpenFindRoad
      );
    }
    $(`#${this.sWrapper}`).on('change', '.company__select select', e =>
      this.onChangeShopName(e)
    );
  }

  clearEvent() {
    if (this.sWrapper) {
      $(`#${this.sWrapper}`).off('click', '[data-role=toggleButton]');
      $(`#${this.sWrapper}`).off('click', '[data-role=openInfo]');
      $(`#${this.sWrapper}`).off('click', '[data-role=openFindRoad]');
      $(`#${this.sWrapper}`).off(
        'click',
        '.company__select [data-role=selectShop]'
      );
    }
  }

  /**
   * toggle eventListener
   */
  onClickToggle = e => {
    const bToggle = $(e.currentTarget).hasClass('open');

    $(`#${this.sWrapper} .toggle`).removeClass('open');

    if (bToggle) {
      $(e.currentTarget).removeClass('open');
    } else {
      $(e.currentTarget).toggleClass('open');
    }
  };

  /**
   * 지도보기 뷰 열기 eventListener
   */
  onClickOpenInfo = e => {
    if (TMON.oApp.sPlatform === 'PW') {
      return;
    }

    e.preventDefault();

    const nCurIdx = $(e.currentTarget).data('idx');
    const { localShopList } = TMON.oApp.htStorage.htStaticData.htDealInfo;

    if (!localShopList) {
      return;
    }
    if (TMON.view_mode !== 'app') {
      // 앱에서는 콜앱을 통해 지도 페이지를 열기 때문에, 현재 페이지의 hash 값을 변경할 필요가 없다. (변경해서는 안된다)
      TMON.util.setHashJSON({
        tab: 'partnerInfo',
        scene: 'scene-partnerinfo',
        idx: nCurIdx,
      });
    }
    this.showInfo(nCurIdx);
  };

  showInfo = nCurIdxForApp => {
    const { localShopList } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    let nCurIdx = null;
    const htHash = TMON.util.getHashJSON();
    if (TMON.view_mode === 'app') {
      // 앱일 때
      nCurIdx = nCurIdxForApp;
    } else {
      // 웹일 때
      nCurIdx = htHash.idx;
    }
    if (typeof nCurIdx !== 'number' && typeof nCurIdx !== 'string') {
      return;
    }
    const {
      shopName,
      address,
      sPhoneNoToCall,
      sFindMapUrl,
      location: { lat, lon: lng },
    } = localShopList[nCurIdx];

    if (TMON.view_mode === 'app') {
      TMON.app.callApp(
        'webview',
        'showNaverMap',
        JSON.stringify({
          vendorName: shopName,
          vendorTel: sPhoneNoToCall,
          address,
          latitude: lat,
          longitude: lng,
          isMultiPoint: localShopList.length !== 1,
        })
      );
      return;
    }

    TMON.oApp.setStorage('openLayerInApplication', true);

    TMON.oApp.setStorage('partnerInfoDetail', {
      shopName,
      address,
      sPhoneNoToCall,
      sFindMapUrl,
      bIsMultiPartner: localShopList.length !== 1,
    });

    TMON.oApp.setStorage('renderMap', {
      sWrapperId: 'partnerInfoDetailMap',
      bIsAvailableInteractMap: true,
      lat,
      lng,
    });
  };

  /**
   * 길찾기 eventListener
   */
  onClickOpenFindRoad = e => {
    const nCurIdx = $(e.currentTarget).data('idx');
    const { localShopList } = TMON.oApp.htStorage.htStaticData.htDealInfo;

    const {
      shopName,
      location: { lat, lon: lng },
    } = localShopList[nCurIdx];

    TMON.app.callApp(
      'webview',
      'getDirectionsByNaverMap',
      JSON.stringify({
        vendorName: shopName,
        latitude: lat,
        longitude: lng,
      })
    );

    e.preventDefault();
  };

  /**
   * PC 다지점일 때 select box 에서 지점명 선택시 업체정보 내용을 교체함
   * @param e
   */
  onChangeShopName = e => {
    const welNamebutton = $(e.currentTarget);
    const nCurIdx = welNamebutton.val();
    const htSelectedShop =
      TMON.oApp.htStorage.htStaticData.htDealInfo.localShopList[nCurIdx];

    // 선택한 지점명으로 select 라벨 교체
    welNamebutton
      .closest('div.company__select')
      .find('[data-role=showSelected]')
      .first()
      .text(htSelectedShop.shopName);

    // 업체정보 교체
    $(`#${this.sWrapper}`)
      .find('.ct_wrp')
      .first()
      .html(this.getDetailInfoHtml(htSelectedShop, nCurIdx));
    $('#partnerInfoMap').data('idx', nCurIdx);
    if (htSelectedShop.location.lat && htSelectedShop.location.lon) {
      this.renderMap(nCurIdx);
      $('.company__box').removeClass('no_map');
    } else {
      $('.company__box').addClass('no_map');
    }
  };

  render() {
    const { localShopList } = TMON.oApp.htStorage.htStaticData.htDealInfo;

    const sHtml =
      localShopList.length === 1 ||
      (TMON.oApp.sPlatform === 'PW' && localShopList.length > 0)
        ? `${
            TMON.oApp.sPlatform === 'PW'
              ? `<h3 class="company__tit">업체정보</h3>${this.getShopSelectHtml()}<div class="company__box no_map">`
              : ''
          }
            <div class="bx_map">
                <div id="partnerInfoMap" ${
                  TMON.oApp.sPlatform !== 'PW' ? 'data-role="openInfo"' : ''
                } class="map_area" data-idx="${0}"></div>
            </div>
            <div class="bx_ct">
                <div class="ct_wrp">
                    ${this.getDetailInfoHtml(localShopList[0], 0)}
                </div>
            </div>
            ${TMON.oApp.sPlatform === 'PW' ? '</div>' : ''}`
        : localShopList
            .map((item, idx) => this.getTitledInfoHtml(item, idx))
            .join('');

    $(`#${this.sWrapper}`).html(sHtml);
  }

  getDetailInfoHtml = (item, idx) => {
    if (!item) {
      return '';
    }
    const sHtml = `<div class="company_info_area">
            ${
              TMON.oApp.sPlatform === 'PW' && item.shopName
                ? `<h4 class="info__area__tit">${item.shopName}</h4>`
                : ''
            }
            <div class="btn">
                ${
                  item.sPhoneNoToCall && TMON.oApp.sPlatform !== 'PW'
                    ? `<a data-role="callToPartner" href="tel:${item.sPhoneNoToCall}" data-tlarea="CBTN" data-tlord="1"> <i class="ico_tel"></i><strong>전화걸기</strong> </a>`
                    : ''
                }
                ${
                  item.location &&
                  item.location.lat !== 0 &&
                  item.location.lon !== 0
                    ? `<a data-role="openInfo" data-idx="${idx}" href="${`http://map.naver.com/?lat=${item.location.lat}&lng=${item.location.lon}&dlevel=13&pinTitle=${item.shopName}`}" target="_blank" data-tlarea="MBTN" data-tlord="1"> <i class="ico_map"></i> <strong>지도보기</strong> </a>`
                    : ''
                }
                <a data-role="openFindRoad" data-idx="${idx}" href="${
      item.sFindMapUrl
    }" target="_blank" data-tlarea="MBTN" data-tlord="2"> <i class="ico_road"></i> <strong>길찾기</strong> </a>
            </div>
            <ul class="list_info">
                <li><strong>주소</strong><span>${item.address}</span></li>
                <li><strong>전화번호</strong><span>${item.phone}</span></li>
                ${
                  item.additionalInfo
                    ? item.additionalInfo
                        .map(addInfoItem =>
                          addInfoItem.desc && addInfoItem.desc !== 'null'
                            ? `<li><strong>${addInfoItem.title}</strong><span>${addInfoItem.desc}</span></li>`
                            : ''
                        )
                        .join('')
                    : ''
                }
            </ul>
        </div>`;
    return sHtml;
  };

  getTitledInfoHtml = (item, idx) =>
    `<div class="bx_ct">
            <div class="ct_wrp">
                <button type="button" class="toggle tit_align_top" data-role="toggleButton"><h4>${
                  item.shopName
                }</h4></button>
                <div class="ct slide-ct">${this.getDetailInfoHtml(
                  item,
                  idx
                )}</div>
            </div>
        </div>`;

  /**
   * PC 일 때 다지점 선택 select 박스를 보여준다
   */
  getShopSelectHtml = () => {
    const { localShopList } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    if (localShopList.length <= 1) {
      return '';
    }

    return `<div class="company__chain">
                    <strong class="company__chain_tit">다른지점 보기</strong>
                    <div class="company__select">
                        <label>
                            <span class="tit" data-role="showSelected">${
                              localShopList[0].shopName
                            }</span>
                            <select class="purchase_selector">
                                ${localShopList
                                  .map(
                                    (item, idx) => `
                                    <option value="${idx}">${item.shopName}</option>
                                `
                                  )
                                  .join('')}
                            </select>
                        </label>
                    </div>
                </div>`;
  };

  renderMap(idx) {
    const { localShopList } = TMON.oApp.htStorage.htStaticData.htDealInfo;

    TMON.oApp.setStorage('renderMap', {
      sWrapperId: 'partnerInfoMap',
      bIsAvailableInteractMap: TMON.oApp.sPlatform === 'PW', // pc 이면 지도 인터랙션 켬
      lat: localShopList[idx].location.lat,
      lng: localShopList[idx].location.lon,
    });
  }
}
